import React, { useContext, useEffect, useReducer, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Nav, Tab } from "react-bootstrap";
import "react-datepicker/dist/react-datepicker.css";

import { useDispatch, useSelector } from "react-redux";
import { toast, ToastContainer } from "react-toastify";

import VendorTable from "./vendorTable";
import AddVendorModal from "./addVendorModal";
import { getAllVendorApi } from "../../../../service/vendor/getAllVendors";
import { setLoading } from "../../../../feature/authSlice";
import { findSubMenuByName } from "../../propertyList/MenuUtlis";
import dayjs from "dayjs";
import { getVendorById } from "../../../../service/vendor/getVendorById";
import { redirectToDash } from "../../redirectToDash";
const VendorsList = () => {
  const { PropertyId, customerId } = useSelector((state) => state.auth);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [vendorListArr, setVendorListArr] = useState([]);
  const [apiLoading, setApiLoading] = useState(false);
  const [pageViewVendor, setPageViewVendor] = useState(1);
  const [pageSizeViewVendor, setPageSizeViewVendor] = useState(10);
  const [totalPageViewVendor, setTotalPageViewVendor] = useState(10);
  const [searchValueViewVendor, setSearchValueViewVendor] = useState("");
  const [totalViewVendorCount, setTotalViewVendorCount] = useState(0);
  const [vendorModalView, setVendorModalView] = useState(false);
  const [vendorData, setVendorData] = useState({});
  const { permissions } = useSelector((state) => state.permissionsData);
  const { permissionArr } = useSelector((state) => state.auth);
  const [filterType, setFilterType] = useState(permissionArr.some(role => /(telephone|admin)/i.test(role)) ? 'Telephone' : "Maintenance/Electricity");

  const [modalType, setModalType] = useState(1);
  const handleSearchViewVendor = (e) => {
    // pageViewVendor(1)

    setSearchValueViewVendor(e.target.value);
    if (searchValueViewVendor.trim().length >= 2) {
      onChangePageViewVendor(1);
    }
  };

  const handleChangeRowsPerPageViewVendor = (e) => {
    setSearchValueViewVendor("");
    setPageViewVendor(1);
    setPageSizeViewVendor(e.target.value);
  };

  const onChangePageViewVendor = (e, p) => {
    // setPage(p);
    setPageViewVendor(e);
  };

  const columns = [
    {
      Header: "Vendor Name ",
      Footer: "Vendor Name ",
      accessor: "VendorName",
    },

    {
      Header: "Vendor Email",
      Footer: "Vendor Email",
      accessor: "VendorEmail",
    },
    // { Header: "Customer Account No",
    //   Footer: "Customer Account No",
    //   accessor: "CustomerAccountNo",

    //   },
    {
      Header: "Vendor GSTIN",
      Footer: "Vendor GSTIN",
      accessor: "VendorGSTIN",
    },
    {
      Header: "Vendor Code",
      Footer: "Vendor Code",
      accessor: "VendorCode",
    },
    { Header: "Vendor PAN", Footer: "Vendor PAN", accessor: "VendorPAN" },
    { Header: "Vendor Site", Footer: "Vendor Site", accessor: "VendorSite" },
    { Header: "Action", Footer: "", accessor: "jkjkj" },
  ];

  useEffect(() => {
    onLoadData();
  }, [pageViewVendor, pageSizeViewVendor]);

  function onLoadData(val, val2) {
    let filterType2 = filterType;
    switch (filterType ? filterType : val2) {
      case "Telephone":
        filterType2 = "Type@=Telephone";
        break;
      case "Maintenance/Electricity":
        filterType2 = "Type!@=Telephone";
        break;
      default:
        filterType2 = "Type@=Telephone";
        break;
    }
    setApiLoading(true);
    var data = {
      Filter: `IsActive==true` + "," + filterType2,
      OrderBy: "-Id",
      PageSize: pageSizeViewVendor,
      PageNumber: pageViewVendor,
      Keyword: searchValueViewVendor,
    };
    dispatch(
      getAllVendorApi(
        data,
        (res) => {
          setApiLoading(false);

          setVendorListArr(res.data.result.List);
          setTotalViewVendorCount(res.data.result.TotalCount);
          if (
            parseInt(res?.data?.result?.TotalCount) % pageSizeViewVendor ===
            0
          ) {
            setTotalPageViewVendor(
              parseInt(res?.data?.result?.TotalCount / pageSizeViewVendor)
            );
          } else {
            setTotalPageViewVendor(
              parseInt(res?.data?.result?.TotalCount / pageSizeViewVendor + 1)
            );
          }
        },
        (res) => {
          setApiLoading(false);
        }
      )
    );
  }

  function handleAddVendorModal(type) {
    setModalType(type);
    setVendorModalView(!vendorModalView);
    if (vendorModalView) {
      onLoadData();
    }
  }
  useEffect(() => {
    let typingTimer;

    // Clear the previous typing timer
    clearTimeout(typingTimer);

    // Set a new typing timer
    typingTimer = setTimeout(() => {
      onLoadData();
    }, 1500);

    // Clean up the timer when component unmounts or search values change
    return () => clearTimeout(typingTimer);
  }, [searchValueViewVendor]);

  function handleEditVendor(data) {
    // var data ={
    //   Filter: `IsActive==true`+","+filterType,
    //   OrderBy: "-Id",
    //   PageSize: pageSizeViewVendor,
    //   PageNumber: pageViewVendor,
    //   Keyword: searchValueViewVendor
    // }
    dispatch(
      getVendorById(
        data?.Id,
        (res) => {
          setApiLoading(false);
          setVendorData(res?.data?.result);
          handleAddVendorModal(2);
          // setVendorListArr(res.data.result.List)
          // setTotalViewVendorCount(res.data.result.TotalCount);
          // if (parseInt(res?.data?.result?.TotalCount) % pageSizeViewVendor === 0) {
          //   setTotalPageViewVendor(parseInt(res?.data?.result?.TotalCount / pageSizeViewVendor))
          // } else {
          //   setTotalPageViewVendor(parseInt(res?.data?.result?.TotalCount / pageSizeViewVendor+1))
          // }
        },
        (res) => {
          setApiLoading(false);
        }
      )
    );
  }

  // Helper function to check if a specific action exists in a submenu
  const hasAction = (submenu, actionName) =>
    submenu?.Actions.includes(actionName);

  // Find the "Properties" menu
  const propertiesMenu = findSubMenuByName(permissions, "Vendor");
  const listPropertyMenu = propertiesMenu
    ? findSubMenuByName(propertiesMenu?.SubMenus, "Vendor List")
    : null;
  // Check actions in the "Approved" submenu
  const canAddVendor = listPropertyMenu
    ? hasAction(listPropertyMenu, "AddVendor")
    : false;

  const [toDate, setToDate] = React.useState(dayjs(new Date()));
  const [fromDate, setFromDate] = React.useState(dayjs(new Date()));

  useEffect(() => {
    if (!listPropertyMenu) {
      redirectToDash(navigate, toast)
    }

  }, [])

  return (
    <>
      <ToastContainer />
      <div className="row d-flex justify-content-between">
        <div className="row">
          <div className="col-xxl-12">
            <div className="card">
              <Tab.Container defaultActiveKey="Pending">
                <div className="card-header border-0 pb-2 flex-wrap">
                  <h4 className="heading me-2">Vendor List</h4>
                  {canAddVendor && (
                    <button
                      type="submit"
                      className="btn btn-primary"
                      onClick={() => {
                        handleAddVendorModal(1);
                      }}
                    >
                      Add Vendor +
                    </button>
                  )}
                </div>
                <div className="card-body pt-2">
                  <h4 className="pt-4">
                    {" "}
                    Total Vendors : &nbsp; {totalViewVendorCount}
                  </h4>
                  <VendorTable
                    column={columns}
                    rowsArr={vendorListArr}
                    showLoading={apiLoading}
                    handleChangeRowsPerPagePagination={
                      handleChangeRowsPerPageViewVendor
                    }
                    setPageSizeViewVendor={setPageSizeViewVendor}
                    searchValuePagination={searchValueViewVendor}
                    pageSizePagination={pageSizeViewVendor}
                    handleSearchPagination={handleSearchViewVendor}
                    totalCountPagination={totalPageViewVendor}
                    handleOnChangePagination={onChangePageViewVendor}
                    totalCount={totalViewVendorCount}
                    handleEditVendor={handleEditVendor}
                    onLoadData={onLoadData}
                    fromDate={fromDate}
                    toDate={toDate}
                    setFromDate={setFromDate}
                    setToDate={setToDate}
                    setFilterType={setFilterType}
                  />
                </div>
              </Tab.Container>
            </div>
          </div>
        </div>
      </div>

      {vendorModalView && (
        <AddVendorModal
          vendorModalView={vendorModalView}
          handleVendorModalView={handleAddVendorModal}
          modalType={modalType}
          vendorData={vendorData}
        />
      )}
    </>
  );
};
export default VendorsList;
